import { render, staticRenderFns } from "./fileSetupEdit.vue?vue&type=template&id=19c05152"
import script from "./fileSetupEdit.vue?vue&type=script&lang=js"
export * from "./fileSetupEdit.vue?vue&type=script&lang=js"
import style1 from "./fileSetupEdit.vue?vue&type=style&index=1&id=19c05152&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports